import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/services/installation-services/page.tsx");
